import { useQuery } from '@tanstack/react-query';
import { subscriptions } from '@api/apis';
import { StatusErrors } from '@constants/base';

/* keys */
import { subscriptionsQueryKeys } from './queries.keys';

/**
 * Note: Pass in options to override defaults, if needed.
 * @param id
 *
 * @params: returned:
 * data, isLoading, isError, error, status, isFetching, refetch
 */
type SubscriptionsShowProps = {
  id: number;
  options?: {
    enabled: boolean;
  };
};

export default function useSubscriptionsQueryShow({ id, options }: SubscriptionsShowProps) {
  const defaultOptions = {};

  /* merge default options with passed in options */
  const mergedOptions = { ...defaultOptions, ...options };

  return useQuery({
    queryKey: subscriptionsQueryKeys.show(id),

    queryFn: async () => {
      const { data } = await subscriptions.show({ id });

      return {
        plan: data?.plan || {},
        status: data?.status || StatusErrors.get(500),
      };
    },
    ...mergedOptions,
  });
}
